export function filterDownloadMedia() {
    const downloadFilters = document.querySelectorAll(".pul-media-downloads-block [data-filter-download]");
    const downloadItems = document.querySelectorAll(".pul-media-downloads-block [data-filter-download-category]");

    if (downloadFilters.length > 0 && downloadItems.length > 0) {
        for (const downloadFilter of downloadFilters) {
            downloadFilter.addEventListener("click", () => {
                // remove active class from all filters
                downloadFilter.closest(".pul-media-downloads-block__filters").querySelector(".active").classList.remove("active");

                // add active class
                downloadFilter.classList.add("active");

                // filter contacts based on the clicked filter
                const filter = downloadFilter.getAttribute("data-filter-download");
                
                for (const downloadItem of downloadItems) {
                    if (downloadItem.dataset.filterDownloadCategory === filter || filter === "all") {
                        downloadItem.classList.remove("hidden");
                    } else {
                        downloadItem.classList.add("hidden");
                    }
                }
            })
        }
    }
}